/**
 * The one hostname on which tools that must never run outside production are
 * armed. Matched by exact equality, never a suffix or pattern, for the same
 * reason the Plausible gate in src/index.html does: a suffix test would arm
 * every host ending in it. consent-gate-parity.spec.ts pins this literal to
 * helm/prod.yml's ingress.endpoint, so renaming the deployment cannot silently
 * disarm or misarm anything.
 */
export const PRODUCTION_HOST = 'shop.igive.no';
